import { SearchCriteria } from './data/search-criteria';
import { UtilsService } from './utils.service';
import { Injectable } from '@angular/core';

const LAB_COMPLETED_PRIVATE_STATUS = 'COMPLETED_PRIVATE_ORDER_98';

@Injectable()
export class SearchCriteriaValidationService {

  constructor() { }

  message = '';

  // validate the search criteria and generate a message if not valid.
  public valid(searchCriteria: SearchCriteria): boolean {

    console.log('start SearchCriteriaValidationService.valid()');
    // default to true, since other order statuses required no additional criteria.
    let validSearchCriteria = true;

    // don't enter both last name and invoice number
    if (this.patientLastNameValid(searchCriteria) && this.invoiceNumberValid(searchCriteria)) {
      this.message = 'Enter either Patient Last name or Invoice Number, but not both.';
      validSearchCriteria = false;
    }

    console.log('validSearchCriteria: ' + validSearchCriteria);
    return validSearchCriteria;
  }

  // return any message generated by validation service.
  public getMessage(): string {
    return this.message;
  }

  // search for lab orders of completed status.
  private isCompletedStatus(searchCriteria: SearchCriteria): boolean {
    let returnValue  = false;

    for (const status of searchCriteria.statuses) {

      if (LAB_COMPLETED_PRIVATE_STATUS === status) {

        returnValue = true;
      }
    }
    return returnValue;
  }

  private patientLastNameValid(searchCriteria: SearchCriteria): boolean {
    // Patient name is mandatory only if the search by completed status with patient name is chosen
    // TODO: Until API search improves to accept search by multiple statuses, we are only accepting
    // completed private status. See https://jira.vspglobal.com/browse/LAB-432

    if (UtilsService.isEmpty(searchCriteria.lastName)) {
      return false;
    }
    return true;
  }

  private invoiceNumberValid(searchCriteria: SearchCriteria): boolean {
    // Invoice Number is mandatory only if the search by completed status with invoice number is chosen.
    // TODO: Until API search improves to accept search by multiple statuses, we are only accepting
    // completed private status. See https://jira.vspglobal.com/browse/LAB-432

    if (UtilsService.isEmpty(searchCriteria.invoiceNumber)) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/searchcriteria-validation.service.ts